// Function to calculate fees paid based on amount
const calculateFeesPaid = (amount, isCard = true) => {
    let fee;

    if (isCard) {
        // Calculate card fee: 2.9% of the amount + $0.30
        fee = (amount * 0.029) + 0.30;
    } else {
        // Calculate ACH fee: 0.8% of the amount, capped at $5.00
        fee = Math.min(amount * 0.008, 5.00);
    }

    // Round the fee to the nearest cent and return it
    return Math.round(fee * 100) / 100;
};

// Converts cents (integer) to dollars (string) with 2 decimal places
const formatCentsToDollars = (cents) => {
    if (typeof cents !== 'number') return '0.00';
    return (cents / 100).toFixed(2);
};

// Converts dollar string or number to cents (integer)
// It can handle inputs like '10.00', '10.0', '10', or 10
const formatDollarsToCents = (dollars) => {
    const amount = parseFloat(dollars);
    if (isNaN(amount)) return 0;
    return Math.round(amount * 100);
};

const formatToDollars = (amount) => {
    return Number(amount).toFixed(2);
};

// Function to format date to a readable table string
function formatDateToTableString(inputDate) {
    const date = new Date(inputDate);
    if (!(date instanceof Date) || isNaN(date)) {
        return 'Invalid date';
    }

    const day = date.getDate();
    const daySuffix = getDaySuffix(day);
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();

    return `${month} ${day}${daySuffix}, ${year}`;
}

function formatDateTimeToLocalString(inputDate) {
    const date = new Date(inputDate);
    if (!(date instanceof Date) || isNaN(date)) {
        return 'Invalid date';
    }

    // Format the date and time to the user's local time zone
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true, // 12-hour format with AM/PM
    };
    return date.toLocaleString(undefined, options);
}

// Helper function to get the suffix for a day
function getDaySuffix(day) {
    if (day > 3 && day < 21) return 'th'; // covers 11th to 20th
    switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
    }
}

const capitalizeWords = (str) => {
    return str.toLowerCase().split(' ').map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  }


// Exporting the functions
module.exports = {
    calculateFeesPaid,
    formatCentsToDollars,
    formatDollarsToCents,
    formatToDollars,
    formatDateToTableString,
    formatDateTimeToLocalString,
    capitalizeWords
};
